if (!customElements.get('project-calculator')) {
  class ProjectCalculator extends HTMLElement {
    constructor() {
      super()
      this.lengthInput = this.querySelector('[data-length]')
      this.widthInput = this.querySelector('[data-width]')

      this.area = this.querySelector('#area')
      this.grids = this.querySelector('#grids')
      this.gravel = this.querySelector('#gravel')
      this.pins = this.querySelector('#pins')
      this.textile = this.querySelector('#textile')

      this.lengthInput.addEventListener('input', this.calcProject.bind(this))
      this.widthInput.addEventListener('input', this.calcProject.bind(this))
    }

    calcProject() {
      const length = parseFloat(this.lengthInput.value) || 0;
      const width = parseFloat(this.widthInput.value) || 0;
      const area = length * width;

      const gridArea = 0.25; // each grid covers 0.25 m²
      const grids = Math.ceil(area / gridArea);
      const gravel = area * 0.07;
      const pins = length * 4;
      const textile = Math.ceil(area / 2);

      if (this.area) this.area.textContent = area.toFixed(1);
      if (this.grids) this.grids.textContent = grids;
      if (this.gravel) this.gravel.textContent = gravel.toFixed(1);
      if (this.pins) this.pins.textContent = pins;
      if (this.textile) this.textile.textContent = textile;
    }
  }

  customElements.define('project-calculator', ProjectCalculator)
}
